import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Spinner } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { OPEN_STATUSES, REQUEST_STATUSES, RIGHTS, StatusPill } from "@/components/privacy/RightsRequests";
import { Card, History, Pick, dueIn } from "@/pages/admin/privacy/shared";

const RequestRow = ({ r, onDone }) => {
  const [status, setStatus] = useState(r.status);
  const [note, setNote] = useState("");
  const [response, setResponse] = useState(r.response || "");
  const save = async () => { try { await api.patch(`/admin/privacy/requests/${r.id}`, { status, note, response }); toast.success("Request updated"); setNote(""); onDone(); } catch (e) { toast.error(errMsg(e)); } };
  const open = OPEN_STATUSES.includes(r.status);
  return (
    <Card testid={`admin-request-${r.id}`}>
      <div className="flex flex-wrap items-center gap-2"><b className="text-sm">{RIGHTS[r.type] || r.type}</b><StatusPill status={r.status} />
        <span className="text-xs text-slate-500">{r.user_name}{r.user_email && ` · ${r.user_email}`} · {r.jurisdiction} · sent {fmtDate(r.created_at)}</span>
        <span className={`ml-auto text-xs font-semibold ${r.overdue ? "text-rose-700" : "text-slate-500"}`} data-testid={`request-due-${r.id}`}>{open ? dueIn(r.due_at) : `closed ${fmtDate(r.closed_at)}`}</span></div>
      {r.details && <p className="text-sm text-slate-700">“{r.details}”</p>}
      <div className="grid gap-2 sm:grid-cols-[11rem_1fr]"><Pick value={status} onChange={setStatus} options={REQUEST_STATUSES} testid={`request-status-${r.id}`} className="w-full" />
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Internal note (optional)" data-testid={`request-note-${r.id}`} /></div>
      <Textarea rows={2} value={response} onChange={(e) => setResponse(e.target.value)} placeholder="Reply shown to the member" data-testid={`request-response-${r.id}`} />
      <div className="flex items-center justify-between gap-3"><History items={r.history} /><Button size="sm" className="rounded-full px-5" onClick={save} data-testid={`request-save-${r.id}`}>Save</Button></div>
    </Card>
  );
};

export const Requests = () => {
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("all");
  const load = () => api.get("/admin/privacy/requests", { params: filter === "all" ? {} : { status: filter } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [filter]); // eslint-disable-line
  if (!rows) return <Spinner />;
  return (
    <div className="space-y-3" data-testid="admin-requests">
      <div className="flex flex-wrap items-center justify-between gap-2"><p className="text-sm text-slate-600">Member rights requests, earliest deadline first. Members see status changes and your reply in their Privacy Centre.</p>
        <Pick value={filter} onChange={setFilter} options={["all", ...REQUEST_STATUSES]} testid="requests-filter" /></div>
      {rows.length === 0 ? <p className="text-sm text-slate-500" data-testid="requests-empty">No requests.</p> : rows.map((r) => <RequestRow key={`${r.id}-${r.history.length}`} r={r} onDone={load} />)}
    </div>
  );
};
